import { Component, OnInit } from '@angular/core';
import { ProjectDetailInstance } from '../project-detail.instance';
import { ProjectFeedService } from '../../project-feed.service';
import { ProjectFeedLog } from '../../../models/project';

@Component({
  selector: 'cw-project-detail-feed',
  templateUrl: './project-detail-feed.component.html',
  styleUrls: ['./project-detail-feed.component.scss']
})
export class ProjectDetailFeedComponent implements OnInit {
  syncing: boolean;
  logItems: ProjectFeedLog[];
  isLoadingRawFeed: boolean = false;
  rawContent: string;

  constructor(private instance: ProjectDetailInstance,
              private feedService: ProjectFeedService) {
    this.instance.$project.subscribe(project => {
      if (project) {
        this.loadFeedLog();
      }
    });
  }

  ngOnInit() {
  }

  sync() {
    this.syncing = true;
    this.feedService.sync(this.instance.project)
      .subscribe(job => {
      });
  }

  loadFeedLog() {
    this.feedService.getLog(this.instance.project).subscribe(logItems => {
      this.logItems = logItems;
    });
  }

  loadRawFeed() {
    this.isLoadingRawFeed = true;
    this.feedService.loadRaw(this.instance.project)
      .finally(() => this.isLoadingRawFeed = false)
      .subscribe(content => {
        this.rawContent = content;
      });
  }

  get project() {
    return this.instance.project;
  }

}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail-feed/project-detail-feed.component.ts